import EffectBase from './EffectBase';

/**
* 处理直角线圈的副作用功能
*/
class EffectLine extends EffectBase {
  constructor(props) {
    super(props);
  }
}

export default EffectLine;